
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Message from '@/components/message.vue';
import dialog from '@/components/dialog.vue';
import uploadImg from "@/components/upload-img.vue"
import {
	activityWheelSurfprizesDrawnedDatatatistics,
	activityWheelSurfactivityWheelSurfPrizeName,
	activityWheelSurfprizesDrawnedDataPageInit,
	activityWheelSurfinvalidPrize,
	activityWheelSurfactivityWheelSurfRewardSendImport
} from "@/api/live"
import axios from 'axios';
@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate,
		'slz-message': Message,
		'slz-dialog': dialog,
		uploadImg
	}
})

export default class ProductList extends Vue {
	private loading = false
	private overview: any = {}
	private keywords = ''
	private prize = null
	private prizelist: any = []
	private state = null
	private statelist = [
		{ value: null, label: '全部' },
		{ value: 0, label: '已使用' },
		{ value: 1, label: '未使用' },
		{ value: 2, label: '已失效' },
	]
	private tablelist: any = [{}]
	private tableloading = false
	private total = 0
	private pageSize = 10
	private pageNo = 1
	private rowmsg: any = {}
	private stopShow = false
	private importShow = false
	private filePath: string[] = []
	private fileName = ''
	private importMsg: any = {
		schedule: 0,
		filePath: [],
		fileName: '',
		FailCount: 0,
		RecordId: 0,
	}
	private sucShow = false
	private mounted() {
		this.getoverview()
		this.getnamelist()
		this.gettablelist()
	}


	private async getnamelist() {
		try {
			let res = await activityWheelSurfactivityWheelSurfPrizeName({
				ActivityWheelSurfId: this.$route.query.Id
			})
			if (res.IsSuccess) {
				this.prizelist = [{ value: null, label: '全部' }, ...res.Result.map(v => {
					return {
						value: v.Id,
						label: v.PrizeName
					}
				})]
			}
		} finally {
			//
		}
	}
	private async getoverview() {
		try {
			this.loading = true
			let res = await activityWheelSurfprizesDrawnedDatatatistics({
				ActivityWheelSurfId: this.$route.query.Id
			})
			if (res.IsSuccess) {
				this.overview = res.Result
			}
		} finally {
			this.loading = false
		}
	}
	private importResult() {
		// console.log(this.importMsg.RecordId)
		this.getresult(this.importMsg.RecordId, true)
	}
	private async confirmImport() {
		if (!this.importMsg.filePath || !this.importMsg.filePath.length) {
			this.$message.error('请上传文件')
			return
		}
		try {
			this.sucShow = true
			this.importMsg.schedule = 1
			let res: any = await activityWheelSurfactivityWheelSurfRewardSendImport({
				ActivityWheelSurfId: this.$route.query.Id,
				ExcelFilePath: this.importMsg.filePath[0],
				ExcelFileName: this.importMsg.fileName
			})
			if (res.IsSuccess) {
				this.importMsg.RecordId = res.Result.RecordId
				this.getresult(res.Result.RecordId, false)
			}
		} catch {
			this.sucShow = false
			this.importMsg.schedule = 1
		}
		finally {
			// this.importMsg.schedule = 2
		}
	}
	private async getresult(RecordId, IsExport) {
		try {
			let res: any = await axios.get('/pc/activityWheelSurf/activityWheelSurfRewardSendImportResultExport' + `?RecordId=${RecordId}&IsExport=${IsExport}`, {
				responseType: IsExport ? 'blob' : undefined,
			})
			if (!IsExport) {
				if (res.data.IsSuccess) {
					this.importMsg = {
						...res.data.Result,
						schedule: 1,
						RecordId: RecordId
					}
					if (!res.data.Result.IsDealFinish) {
						setTimeout(() => {
							this.getresult(RecordId, false)
						}, 500)
					} else {
						this.importMsg = {
							...res.data.Result,
							schedule: 2,
							RecordId: RecordId
						}
						this.sucShow = true
					}
				} else {
					this.$message.error(res.data.Message)
					this.sucShow = false
				}
			} else {
				let blob = new Blob([res.data], { type: "application/octet-stream; charset=utf-8" })
				let a = document.createElement('a')
				a.style.display = 'none'
				a.download = `导入中奖物流反馈表格.xlsx`
				a.href = URL.createObjectURL(blob)
				a.click()
				a.remove()
			}
		} finally {
			//
		}
	}
	private importCancel() {
		this.importShow = false
		this.sucShow = false
		this.importMsg = {
			schedule: 0,
			filePath: [],
			fileName: '',
			failCount: 0
		}
	}
	private uploadSuc(file, name) {
		this.importMsg.filePath = file
		this.importMsg.fileName = name
	}
	private exportfile() {
		let url = location.origin + '/pc/activityWheelSurf/prizesDrawnedDataExport'
		url += '?ActivityWheelSurfId=' + this.$route.query.Id
		url += '&Keywords=' + encodeURIComponent(this.keywords)
		url += '&ActivityWheelSurfPrizeId=' + (this.prize == null ? '' : this.prize)
		url += '&State=' + (this.state == null ? '' : this.state)
		window.open(url)
	}
	private async confirmstop() {
		try {
			this.tableloading = true
			let res: any = await activityWheelSurfinvalidPrize({
				Id: this.rowmsg.Id
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.stopShow = false
				this.gettablelist()
			}
		} finally {
			this.tableloading = false
		}
	}
	private tostop(row) {
		this.rowmsg = row
		this.stopShow = true
	}
	private async gettablelist() {
		try {
			this.tableloading = true
			let res: any = await activityWheelSurfprizesDrawnedDataPageInit({
				ActivityWheelSurfId: this.$route.query.Id,
				Keywords: this.keywords,
				ActivityWheelSurfPrizeId: this.prize,
				State: this.state,
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize
			})
			if (res.IsSuccess) {
				this.tablelist = res.Result.Results
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading = false
		}
	}
	private changePage(e) {
		this.pageNo = e
		this.gettablelist()
	}
	private doSearch() {
		this.changePage(1)
	}
	private clearSearch() {
		this.keywords = ''
		this.state = null
		this.prize = null
		this.changePage(1)
	}
}
